import React from 'react'
import "./error.scss"
import { Link } from 'react-router-dom'



const Error = () => {
  return (
    <>
      {/* <Pagetop  text="404" /> */}

      <div className="error-parent parent">
        <div className="error-cont container">
            <h2 className='errortext'>
                404
            </h2>
            <p>
                Page Not Found
            </p>
            <Link className="cta-btn" to="/"> Back To Home</Link>
        </div>
      </div>
    </>
  )
}

export default Error
